import { Document, Font, Image, Page, Text, View } from "@react-pdf/renderer";
import ThSarabun from "../../fonts/THSarabunNew.ttf";
import ThSarabunBold from "../../fonts/THSarabunNew-Bold.ttf";
import ThSarabunItalic from "../../fonts/THSarabunNew-Italic.ttf";
import ThSarabunBoldItalic from "../../fonts/THSarabunNew-BoldItalic.ttf";
import PromptRegular from "../../fonts/prompt/Prompt-Regular.ttf";
import Browallia from "../../fonts/browallia/BrowalliaUPC2.ttf";
import { BillStylesA4 as styles } from "./BillStyle";
import {
  getDecimalString,
  GetPatientAge,
  GetPatientSex,
  GetThaiBahtString,
} from "../../core/Helper2";

export const RegisterFont = () => {
  Font.register({ family: "ThSarabun", src: ThSarabun });
  Font.register({ family: "ThSarabunBold", src: ThSarabunBold });
  Font.register({ family: "ThSarabunItalic", src: ThSarabunItalic });
  Font.register({ family: "ThSarabunBoldItalic", src: ThSarabunBoldItalic });
  Font.register({ family: "PromptRegular", src: PromptRegular });
  Font.register({ family: "Browallia", src: Browallia });
};

export const GetDocuHeaderSection = async ({ printInfo }) => {
  const { Branch, DocuType } = printInfo?.DocuBranch?.BranchDocu;
  return (
    <View>
      <View style={styles.pageHeader}>
        <View>
          <View style={styles.companyBox}>
            <View style={styles.headerLogo}>
              <Image
                style={styles.logo}
                src={"/logos/logo_comp_" + Branch.Company?.CompId + ".png"}
              />
            </View>
            <View>
              <Text style={styles.textSmall}>{Branch.Company?.CompNameTh}</Text>
              <Text style={styles.textVerySmall}>
                {Branch.Company?.CompAddrTh}
              </Text>
              <Text style={styles.textVerySmall}>
                {Branch.Company?.CompAddrTh2}
              </Text>
              <Text style={styles.textVerySmall}>
                โทร.{Branch.Company?.Phone} เลขประจำตัวผู้เสียภาษี{" "}
                {Branch.Company?.Taxid}
              </Text>
            </View>
          </View>

          <View style={{ height: "5px" }} />
          <Text style={styles.textSmall}>{Branch?.BrchName}</Text>
          <Text style={{ ...styles.textVerySmall, color: "#000000" }}>
            {
              Branch?.BrchAddr1 + " " + Branch?.BrchAddr2 + " " + ""
              // Branch.BrchPhone
            }
          </Text>
        </View>

        <View>
          <View style={styles.docuNameBox}>
            <Text style={styles.textVeryLarge}>{DocuType?.DocuTypeText} </Text>
          </View>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>เลขที่เอกสาร </Text>
            <Text style={styles.textSmall}>{printInfo?.DocuNo} </Text>
          </View>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>วันที่เอกสาร </Text>
            <Text style={styles.textSmall}>
              {new Date().toLocaleDateString()}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};
export const GetDocuCustomerSection = async ({ printInfo }) => {
  const { Study } = printInfo;
  // console.log(Study);
  return (
    <View>
      <View style={styles.horizonView}>
        <View style={styles.customerDetailBox}>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>ออกให้กับ:</Text>
            <Text style={styles.textValue}>{printInfo?.BillTo}</Text>
          </View>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>ที่อยู่:</Text>
            <Text style={styles.textValue}>{printInfo?.BillAddr1}</Text>
          </View>

          <View style={styles.horizonView}>
            <Text style={styles.textValue}>{printInfo?.BillAddr2}</Text>
          </View>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>โทรศัพท์:</Text>
            <Text style={styles.textValue}>{printInfo?.BillPhone}</Text>
          </View>
        </View>

        <View style={styles.customerDetailBox}>
          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>ชื่อคนไข้: </Text>
            <Text style={styles.textValue}>{Study?.PatientsName} </Text>
          </View>

          <View style={styles.horizonView}>
            <Text style={styles.textLabel}>เลขที่บัตร: </Text>
            <Text style={styles.textValue}>{Study?.PatientIdCard} </Text>
          </View>

          <View style={{ ...styles.horizonView, justifyContent: "flex-start" }}>
            <View style={styles.horizonView}>
              <Text style={styles.textLabel}>อายุ: </Text>
              <Text style={styles.textValueNoFlex}>
                {GetPatientAge(Study?.PatientsAge)}
              </Text>
            </View>
            <View style={styles.horizonView}>
              <Text style={styles.textLabel}>เพศ: </Text>
              <Text style={styles.textValueNoFlex}>
                {GetPatientSex(Study?.PatientsSex)}
              </Text>
            </View>
          </View>
          <View style={styles.horizonView}>
            <View style={styles.horizonView}>
              <Text style={styles.textLabel}>สิทธิการรักษา: </Text>
              <Text style={styles.textValue}>
                {Study?.BranchPatientRight?.BrchRightName}
              </Text>
            </View>
          </View>
        </View>
      </View>

      {/* <View style={styles.drawLine}></View> */}
      {/*  */}
      <View style={styles.horizonView}>
        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>รพ/คลินิก: </Text>
          <Text style={styles.textValue}>
            {Study?.CustomerSender?.CustName}
          </Text>
        </View>

        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>HN: </Text>
          <Text style={styles.textValue}>{Study?.PatientId} </Text>
        </View>

        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>วอร์ด: </Text>
          <Text style={styles.textValue}>{Study?.BranchWard?.WardName} </Text>
        </View>

        <View style={{ ...styles.horizonView, flex: "1" }}>
          <Text style={styles.textLabel}>แพทย์ส่ง: </Text>
          <Text style={styles.textValue}>
            {Study?.Physician &&
              Study?.Physician?.FullFirstName +
                " " +
                Study?.Physician?.LastName}
          </Text>
        </View>
      </View>
    </View>
  );
};

export const GetDocuFooterSection = async ({ StudyItems, Summary }) => {
  const objPrice = (text, item) => {
    return (
      <View style={styles.horizonView}>
        <Text style={styles.textLabel}>{text} </Text>
        <Text style={styles.itemPrice}>{item} </Text>
      </View>
    );
  };

  return (
    <View>
      <View style={styles.pageHeader}>
        {/* Left Panel */}
        <View style={{ flex: "2", marginRight: "2px" }}>
          <View style={{ ...styles.horizonView, display: "flex" }}>
            <Text style={styles.textLabel}>รวม</Text>
            <Text
              style={{
                ...styles.textValue,
                paddingHorizontal: "10px",
                flex: "1",
              }}
            >
              {StudyItems?.length ?? 0} {"  รายการ"}
            </Text>
          </View>

          <Text style={styles.textLabel}>รวมเป็นเงินทังสิ้น(ตัวอักษร):</Text>
          <View style={styles.thaiBaht}>
            <Text style={styles.textLabel}>
              {GetThaiBahtString(Summary?.NetTotal)}
            </Text>
          </View>
        </View>
        {/* Right Panel */}
        <View style={{ flex: "1", marginLeft: "2px" }}>
          {objPrice("ราคารวม", getDecimalString(Summary?.Amount, 2))}
          {objPrice("ส่วนลด", getDecimalString(Summary?.Discount, 2))}
          {objPrice("ยอดก่อนหักภาษี", getDecimalString(Summary?.Total, 2))}
          {objPrice(
            "อัตราภาษีมูลค่าเพิ่ม",
            getDecimalString(Summary?.VatRate, 2)
          )}
          {objPrice(
            "ยอดรวมภาษีมูลค่าเพิ่ม",
            getDecimalString(Summary?.VatTotal, 2)
          )}
          {objPrice("ยอดสุทธิ", getDecimalString(Summary?.NetTotal, 2))}

          <View style={styles.drawLine} />
          {objPrice(
            "อัตราภาษีหัก ณ ที่จ่าย",
            getDecimalString(Summary?.HoldingTaxRate, 2)
          )}
          {objPrice(
            "ยอดเงินหัก ณ ที่จ่าย",
            getDecimalString(Summary?.HoldingTaxAmount, 2)
          )}
        </View>
      </View>
    </View>
  );
};

export default function BuildDocument(props) {
  const { size } = props;
  RegisterFont();

  const { docHeader, customer, items, footer } = props;

  return (
    <Document style={styles.document}>
      <Page size={size ?? "A4"} style={styles.page}>
        {docHeader}
        {/* <View style={styles.drawLine} /> */}
        {customer}
        <View style={styles.drawLine} />
        <View style={styles.verticalSpacing} />
        {items}
        {/* <View style={styles.drawLine} /> */}
        {footer}
      </Page>
    </Document>
  );
}
